import React, { useEffect, useRef, useState } from "react";
import "./Contact.css";
import { Helmet } from "react-helmet";
import "@fortawesome/fontawesome-free/css/all.css";
import emailjs from "@emailjs/browser";

// Modal Component
const Modal: React.FC<{ message: string; onClose: () => void }> = ({
  message,
  onClose,
}) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <p>{message}</p>
        <button onClick={onClose}>Fermer</button>
      </div>
    </div>
  );
};

const Contact: React.FC = () => {
  const formRef = useRef<HTMLFormElement | null>(null);
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state

  useEffect(() => {
    const header = document.querySelector(".header-container") as HTMLElement;
    if (header) {
      header.style.backdropFilter = `blur(20px)`;
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formRef.current) return;

    console.log("Submitting form..."); // Debugging log
    setIsLoading(true); // Set loading state to true

    try {
      await emailjs.sendForm(
        "service_inhr1t5", // Replace with your EmailJS Service ID
        "template_x1jy761", // Replace with your EmailJS Template ID
        formRef.current,
        "995qwUIkFd25DAvIW" // Replace with your EmailJS Public Key
      );

      setIsLoading(false); // Reset loading state
      setIsModalOpen(true); // Open the modal
    } catch (error) {
      console.error("Failed to send email:", error);
      setIsLoading(false); // Reset loading state
      alert("Échec de l'envoi de votre message. Veuillez réessayer.");
    } finally {
      console.log("Resetting loading state..."); // Debugging log
      setIsLoading(false); // Ensure loading state is reset
    }
  };

  return (
    <div
      className="contact-container"
      style={{
        backgroundSize: "cover",
        backgroundPosition: "bottom",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Helmet>
        <title>Contact | Zied Zouari</title>
      </Helmet>
      <main className="contact-content">
        <div className="contact-form-section">
          <h1>CONTACT</h1>
          <form ref={formRef} onSubmit={handleSubmit} className="contact-form">
            <input type="text" name="user_name" placeholder="Nom" required />
            <input
              type="email"
              name="user_email"
              placeholder="Email"
              required
            />
            <input
              type="text"
              name="user_subject"
              placeholder="Sujet"
              required
            />
            <textarea name="message" placeholder="Message" required></textarea>
            <button type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i> Envoi...
                </>
              ) : (
                "Envoyer le Message"
              )}
            </button>
          </form>
        </div>
      </main>

      {/* Render Modal if isModalOpen is true */}
      {isModalOpen && (
        <Modal
          message="Votre message a été envoyé avec succès."
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};

export default Contact;